import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27c0bd3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-common-info" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sequence" }

import { withDefaults } from 'vue'
import { DeviceCommonInfo } from '@/types/jijia'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-common-info',
  props: {
    info: { default: () => ({
      img: '',
      name: '',
      sequence: '',
    }) }
  },
  setup(__props: any) {

const props = __props as { info: DeviceCommonInfo };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "image",
      style: _normalizeStyle({ backgroundImage: 'url(' + props.info.img + ')' })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.info.name), 1),
      _createElementVNode("div", _hoisted_4, "SN：" + _toDisplayString(props.info.sequence), 1)
    ])
  ]))
}
}

})